import { render, staticRenderFns } from "./WhatsappBusinessChannelDetail.vue?vue&type=template&id=2ce38d03&scoped=true"
import script from "./WhatsappBusinessChannelDetail.vue?vue&type=script&lang=js"
export * from "./WhatsappBusinessChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./WhatsappBusinessChannelDetail.vue?vue&type=style&index=0&id=2ce38d03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce38d03",
  null
  
)

export default component.exports